import React from "react";
//import Highcharts from "highcharts";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import LoaderTemplate from "../../../component/LoaderTemplate";
import { ChartLoaderTemplate } from "./chartLoader";
import { getLocalstorage } from "../../../helper";

Highcharts.setOptions({
  colors: [
    "#4372c4",
    "#ed7d3b",
    "#a5a5a5",
    "#ffc13d",
    "#5a9bd5",
    "#6fad47",
    "#264478",
    "#9d4a24",
    "#636363",
    "#987321"
  ]
});

export function ChartsComponent({
  isLoading,
  loader = <LoaderTemplate times={1} children={<ChartLoaderTemplate />} />,
  classes = "",
  chartConfig = null,
  children = null,
  displayOnDashboard = false,
  displayTitle,
  extraTopSpace = false,
  updateValue,
  displayFooter = false
}) {
  const user = getLocalstorage("user");

  return (
    <section className={classes}>
      {isLoading ? (
        <div className={"chart-loader-container"}>{loader || "Loading..."}</div>
      ) : chartConfig ? (
        <>
          <div className={`high-chart`}>
            {displayOnDashboard ? (
              <div
                className={`${
                  user.groupCategory === "CENTRAL"
                    ? "heading-for-charts-for-center"
                    : "heading-for-charts"
                } ${extraTopSpace ? "extra-top-space" : null}`}
              >
                {displayTitle}
              </div>
            ) : null}
            <HighchartsReact
              highcharts={Highcharts}
              options={{ ...chartConfig, credits: { enabled: false } }}
              key={updateValue}
            />
            {displayFooter ? (
              <div className="graph-footer">
                *Includes projects with delayed milestones only
              </div>
            ) : null}
          </div>
          <div className={"high-chart-content"}>{children}</div>
        </>
      ) : null}
    </section>
  );
}
